import React from 'react';
import { BaseRouterLink } from '@99designs/purgatory';
import { PageType } from './types';

interface AuthLinkProps {
    children: React.ReactNode;
    page: PageType;
    onSetPage: (
        e: React.MouseEvent<HTMLAnchorElement> | null,
        page: PageType,
        link: string | null
    ) => void;
    to: string;
}

function AuthLink({ children, page, onSetPage, to }: AuthLinkProps) {
    return (
        <BaseRouterLink onClick={(e) => onSetPage(e, page, null)} to={to}>
            {children}
        </BaseRouterLink>
    );
}

export default AuthLink;
